<template lang="pug">
  .filters-languages
    .languages-fields(v-for="(language, index) in languages")
      .field
        input.is-checkradio.custom-checkbox(
          type="checkbox"
          :id="`checkbox_${language.name}_${index}`"
          v-model="chosen[index]"
          @input="setLanguage(index, language)"
          :true-value="language")
        label.checkbox(:for="`checkbox_${language.name}_${index}`") {{ language.name }}
      .field.field-level
        v-dropdown(:items="levels" @input="setLevel(index, language, $event)" :value="getLevel(index)")
    additional-languages(:languages="additionalLanguages" :levels="levels" v-model="addition" ref="additional")

</template>
<script>
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import VDropdown from './parts/dropdown'
import AdditionalLanguages from './parts/additional-languages/index'
const _ = require('lodash')

export default {
  name: 'LanguageFilters',
  components: {
    AdditionalLanguages,
    VDropdown
  },
  data () {
    return {
      chosen: [],
      addition: []
    }
  },
  props: {
    languages: {
      default: () => []
    },
    levels: {
      default: () => []
    },
    additional: {
      default: () => []
    },
    value: {
      default: () => []
    }
  },
  methods: {
    gettext: gettext,
    format (data) {
      let map = _.map(_.compact(data), item => {
        return _.filter([item.id, item.level ? item.level.id : item.level])
      })
      let res = _.compact(_.map(map, item => {
        if (item.length > 1) return item
      }))
      return res
    },
    setLanguage (index, lang) {
      this.chosen[index] = lang
      this.chosen[index]['level'] = -1
    },
    setLevel (index, lang, level) {
      if (this.chosen[index]) {
        this.chosen[index]['level'] = level
      }
    },
    getLevel (index) {
      return (this.chosen[index] || {})['level'] || 1
    },
    clearAll () {
      this.chosen = []
      this.addition = []
      this.$refs.additional.setChosen([])
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    additionalLanguages: function () {
      return _.differenceBy(this.additional, this.languages, 'iso_code')
    },
    selectedItems: function () {
      return _.concat(this.format(this.addition), this.format(this.chosen))
    }
  },
  watch: {
    selectedItems: {
      deep: true,
      handler: function (val) {
        this.$emit('input', val)
      }
    },
    value: function (val) {
      let setValue = (item) => {
        if (_.isString(item)) {
          let lang = _.find(this.languages, {'id': parseInt((item.split(','))[0])})
          let levl = _.find(this.levels, {'id': parseInt((item.split(','))[1])})
          if (lang) {
            let key = _.findKey(this.languages, lang)
            this.$set(this.chosen, key, lang)
            if (levl) {
              this.$set(this.chosen[key], 'level', levl)
            }
          } else {
            let addition = _.find(this.additional, {'id': parseInt((item.split(','))[0])})
            let key = _.findKey(this.additional, addition)
            this.$set(this.addition, key, addition)
            if (levl) {
              this.$set(this.addition[key], 'level', levl)
            }
            this.$refs.additional.setChosen(this.addition)
          }
        }
      }
      if (_.isString(val)) {
        let result = _.map(_.chunk(val.split(','), 2), item => {
          return _.join(item, ',')
        })
        _.each(result, item => {
          setValue(item)
        })
      }
    }
  }
}
</script>

<style lang='scss'>
  .filters-languages {
    .field {
      margin-bottom: 0.25rem;
      input.custom-checkbox {
        & + label {
          font-weight: normal;
          margin: 0.1rem;
          font-size: 15px;
          &:after {
            border-color: #bb1d2c !important;
          }
        }
        &:hover {
          & + label {
            &:before {
              border-color: #bb1d2c !important;
            }
          }
        }
      }
      .dropdown {
        .dropdown-trigger {
          button {
            border-left: none;
            height: 32px;
          }
        }
        .dropdown-menu {
          padding-top: 4px;
          .dropdown-content {
            overflow-y: auto;
            .dropdown-item {
              padding: 0 1rem;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/components/language-filters/index.vue